import { computed, ComputedRef } from 'vue';
import { useRoute } from 'vue-router';

export enum ABnFeaturesQuery {
  PP_3474 = 'PP_3474',
}

const useQueryParamTreatment = (toggle: ABnFeaturesQuery): ComputedRef<string> => {
  const route = useRoute();

  return computed(() => {
    return typeof route.query[toggle] === 'string' ? route.query[toggle] : '';
  });
};

export default useQueryParamTreatment;
